import breakfastHot from '../eatfirst/images/breakfast/hot-breakfast.jpg'
import breakfastCold from '../eatfirst/images/breakfast/cold-breakfast.webp'
import afternoonTeaSweet from '../eatfirst/images/afternoon-tea/sweet.webp'
import afternoonTeaSavoury from '../eatfirst/images/afternoon-tea/savoury.jpg'
import afternoonTeaBoth from '../eatfirst/images/afternoon-tea/both.webp'
import lunchClassic from '../feedr/images/lunch/classic.webp'
import lunchBoth from '../feedr/images/lunch/both.webp'
import lunchBowls from './images/lunch_bowls.jpg'
import { EventDetailsType, OccasionFieldsAndEventDetails } from '../types'
import { match } from 'ts-pattern'
import { occasionFoodServiceTime, occasionStaffServiceTime } from '../common'

const eventDetailsDrinks: EventDetailsType = {
  id: 'drinks',
  label: 'emma:eventDetails_drinksSubtitle', // "Would you like to add drinks?"
  type: 'radio',
  needs: [],
  prefill: false,
  options: [
    {
      label: 'common:yes',
      value: 'YES',
    },
    {
      label: 'common:no',
      value: 'NO',
    },
  ],
}

const eventDetailsDrinksType: EventDetailsType = {
  id: 'drinksRequirements',
  label: 'emma:eventDetails_drinksRequirementsSubtitle', // "What sort of drinks do you want?"
  type: 'checkbox',
  needs: [
    {
      id: 'drinks',
      value: 'YES',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Alkoholische',
      value: 'ALCOHOLIC_DRINKS',
    },
    {
      label: 'Nicht-alkoholische',
      value: 'NON_ALCOHOLIC_DRINKS',
    },
    {
      label: 'Tee / Kaffee',
      value: 'TEA_AND_COFFEE',
    },
  ],
}

const eventDetailsEquipment: EventDetailsType = {
  id: 'equipment',
  label: 'emma:eventDetails_equipmentSubtitle', // "Would you like to hire any equipment?"
  type: 'radio',
  needs: [],
  prefill: false,
  options: [
    {
      label: 'common:yes',
      value: 'YES',
    },
    {
      label: 'common:no',
      value: 'NO',
    },
  ],
}

const eventDetailsEquipmentType: EventDetailsType = {
  id: 'equipmentRequirements',
  label: 'emma:eventDetails_equipmentRequirementsSubtitle', // "What equipment do you need?"
  type: 'checkbox',
  needs: [
    {
      id: 'equipment',
      value: 'YES',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Teller & Besteck', // Cutlery & Plates
      value: 'CUTLERY_AND_CROCKERY',
    },
    {
      label: 'Tische', // Tables
      value: 'TABLES',
    },
    {
      label: 'Service Personal', // Service-staff
      value: 'STAFF',
    },
  ],
}

// Specific to MyMy Catering
const occasionRequirements: EventDetailsType = {
  id: 'requirements',
  label: 'Was wünschst Du dir?',
  type: 'checkbox',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Essen',
      value: 'FOOD',
    },
    {
      label: 'Service Personal',
      value: 'EVENT_STAFFING',
    },
    {
      label: 'Barkeeper',
      value: 'BARTENDER_MIXOLOGIST',
    },
    {
      label: 'Grillmeister',
      value: 'GRILL_MASTER',
    },
  ],
}

const occasionEventStyle: EventDetailsType = {
  id: 'eventStyle',
  label: 'Was ist der Stil des Events?',
  type: 'radio',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Flying Fingerfood',
      value: 'COCKTAIL_PARTY',
    },
    {
      label: 'BBQ',
      value: 'BBQ',
    },
    {
      label: 'Klassisches Buffet',
      value: 'BUFFET',
    },
    {
      label: 'Foodtrucks',
      value: 'POP_UP',
    },
    {
      label: 'Andere',
      value: 'OTHER',
    },
  ],
}

// Image Cards

const occasionBreakfastType: EventDetailsType = {
  id: 'subtype',
  label: 'emma:breakfast_question',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'emma:breakfast_types_hot',
      label: undefined,
      value: 'HOT',
      image: breakfastHot,
    },
    {
      title: 'emma:breakfast_types_cold',
      label: undefined,
      value: 'COLD',
      image: breakfastCold,
    },
  ],
}

const occasionDinnerType: EventDetailsType = {
  id: 'subtype',
  label: 'Wie viele Gänge wünschst Du Dir für Dein Dinner?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Vorspeise(n), Hauptspeise(n) und Nachspeise(n)', // starter, main, dessert
      label: undefined,
      value: 'STARTER_MAIN_DESSERT',
      image: lunchClassic,
    },
    {
      title: 'Vorspeise(n) und Hauptspeise(n)', // starter, main
      label: undefined,
      value: 'STARTER_MAIN',
      image: lunchBowls,
    },
    {
      title: 'Nur Hauptspeise(n)', // main only
      label: undefined,
      value: 'MAIN_ONLY',
      image: lunchBoth,
    },
  ],
}

const occasionFingerFoodSimpleType: EventDetailsType = {
  id: 'subtype',
  label: 'Mit welcher Art von Fingerfood dürfen wir Dich überraschen?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Süßes und Herzhaftes', // Sweet and Savoury
      label: undefined,
      value: 'BOTH',
      image: afternoonTeaBoth,
    },
    {
      title: 'Eher Herzhaftes', // More savoury
      label: undefined,
      value: 'SAVOURY',
      image: afternoonTeaSavoury,
    },
    {
      title: 'Eher Süßes', // More sweet
      label: undefined,
      value: 'SWEET',
      image: afternoonTeaSweet,
    },
  ],
}

// Text Fields
const occasionEventType: EventDetailsType = {
  id: 'eventType',
  placeholder: 'Beispiel: Firmenveranstaltung/Event‘',
  label: 'Was ist der Anlass?',
  inputLabel: 'Was ist der Anlass?',
  type: 'text',
  needs: [],
  prefill: false,
}

export const occasions = (code: string): OccasionFieldsAndEventDetails => {
  const result: OccasionFieldsAndEventDetails = {
    skip: false,
    fields: [],
    eventDetails: [],
  }
  match(code)
    .with('BREAKFAST', () => {
      result.fields.push(occasionBreakfastType)
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('MORNING_TEA', () => {
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('LUNCH', () => {
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('DINNER', () => {
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('BUFFET', () => {
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('FINGER_FOOD_SIMPLE', () => {
      result.fields.push(occasionFingerFoodSimpleType)
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('CHRISTMAS', () => {
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
    .with('EVENT_OTHER', () => {
      result.fields.push(
        occasionEventType,
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
      )
      result.eventDetails.push(
        eventDetailsDrinks,
        eventDetailsDrinksType,
        eventDetailsEquipment,
        eventDetailsEquipmentType,
      )
    })
  return result
}
